import e from "./ghl-ui.es766.js";
import y from "./ghl-ui.es742.js";
import r from "./ghl-ui.es767.js";
var a = r && r.isTypedArray, o = a ? y(a) : e;
const i = o;
export {
  i as default
};
